export class Questionnaire {
    constructor(data) {
        this.questionnaire_answer = [];
        this.group_name = new QuestionStructure;
        this.merchant_type = new QuestionStructure;
        this.boarding_platform = new QuestionStructure;
        this.parent_type = new QuestionStructure;
        this.partner_external_id = new QuestionStructure;
        this.outlet_count = new QuestionStructure;
        this.chain = new QuestionStructure;
        this.annual_turnover = new QuestionStructure;
        this.mid = new QuestionStructure;
        this.atv = new QuestionStructure;
        this.country_code = new QuestionStructure;
        this.county_code = new QuestionStructure;
        this.city = new QuestionStructure;
        this.mcc_code = new QuestionStructure;
        this.multiple_outlet = new QuestionStructure;
        this.ecom_transaction_value = new QuestionStructure;
        this.card_acceptance_method = new QuestionStructure;
        this.terminal_manufacturer = new QuestionStructure;
        this.agreement_length = new QuestionStructure;
        this.merchant_hierarchy = new QuestionStructure;
        if (!!data) {
            this.setData(data);
        }
    }

    setData(data) {
        let keys = Object.keys(data);
        keys.map(f => {
            this[f].value = !!data[f] ? new QuestionStructure(data[f]) : '';
        });
    }
}

export class QuestionStructure {
    constructor() {
        this.is_relevant = true;
        this.value = '';
    }
}

export class QuestionnaireAnswer {
    constructor(data) {
        this.question_group_external_id = '';
        this.question_external_id = '';
        this.question_description = '';
        this.answer_values = '';
        this.answer_type = '';
        if (!!data) {
            this.setData(data);
        }
    }

    setData(data) {
        let keys = Object.keys(data);
        keys.map(f => {
            if(f === 'description') {
                this.question_description = !!data[f] ? data[f] : '';
            }
            else if (this.hasOwnProperty(f)) {
                this[f] = !!data[f] ? data[f] : '';
            }
        });
    }
}